import { Badge, BadgeProps } from '@anyui/core';
import { useTranslation } from 'react-i18next';
import {
  WarningReason,
  MarketplaceCampaignPostStatus,
  MarketplaceCampaignPostStatusForAdvertiser
} from '@anytag/graphql';
import { useGetPostWarningReasonStatusProps } from '../shared';

export interface MarketplacePostStatusProps {
  className?: string;
  warningReason?: WarningReason;
  status: MarketplaceCampaignPostStatus | MarketplaceCampaignPostStatusForAdvertiser;
}

export const MarketplacePostStatus = ({ status, warningReason, className }: MarketplacePostStatusProps) => {
  const { t } = useTranslation();
  const { getPostWarningReasonStatusProps } = useGetPostWarningReasonStatusProps();

  const hasReason =
    [MarketplaceCampaignPostStatus.WARNING, MarketplaceCampaignPostStatusForAdvertiser.TRACKING].includes(status) &&
    !!warningReason;
  const statusProps: BadgeProps = (() => {
    if (hasReason) {
      return getPostWarningReasonStatusProps(warningReason);
    } else {
      switch (status) {
        case MarketplaceCampaignPostStatus.APPROVED:
          return { children: t('Option.Approved'), color: 'green' };
        case MarketplaceCampaignPostStatus.EFFECTIVE:
        case MarketplaceCampaignPostStatus.WARNING_SOLVED:
          return { children: t('Option.Effective'), color: 'green' };
        case MarketplaceCampaignPostStatus.WARNING:
          return { children: t('Option.Warning'), color: 'red' };
        case MarketplaceCampaignPostStatus.INEFFECTIVE:
          return { children: t('Option.Ineffective'), color: 'zinc' };
        case MarketplaceCampaignPostStatus.SHIPPED:
          return { children: t('Option.Shipped'), color: 'yellow' };
        case MarketplaceCampaignPostStatusForAdvertiser.JOINED:
          return { children: t('Option.Joined'), color: 'blue' };
        case MarketplaceCampaignPostStatusForAdvertiser.TRACKING:
          return { children: t('Option.Tracking'), color: 'purple' };
        case MarketplaceCampaignPostStatusForAdvertiser.DRAFT:
          return { children: t('Option.Reviewing'), color: 'purple' };
        case MarketplaceCampaignPostStatusForAdvertiser.DRAFT_REJECTED:
          return { children: t('Option.Feedbacked'), color: 'yellow' };
        case MarketplaceCampaignPostStatusForAdvertiser.READY_TO_POST:
          return { children: t('Option.Ready to Post'), color: 'green' };
        default:
          return { children: null, color: 'zinc' };
      }
    }
  })();

  return <Badge {...statusProps} className={className} />;
};
